import { Text, Button, Modal } from '@querodelivery/uni-react';
import styles from './export-fare-modal.module.scss';

import { DropdownInput } from '@/_components/dropdown-input/dropdown-input';
import type { IDropdownOptions } from '@/Interfaces/Data';

interface ExportFareModalProps {
  open: boolean;
  onClose(): void;
  onConfirm(): void;
  options: IDropdownOptions[];
  selectedPlaceIds: string[];
  onSelectionChange(value: string | string[]): void;
}

function ExportFareModal({
  open,
  onClose,
  onConfirm,
  options,
  selectedPlaceIds,
  onSelectionChange,
}: ExportFareModalProps) {
  if (!open) {
    return null;
  }

  return (
    <Modal
      header="Exportar tarifa"
      isOpen={open}
      onClose={onClose}
      width="31.25rem"
    >
      <div className={styles.content}>
        <Text>
          Selecione abaixo os estabelecimentos para exportar a tarifa:
        </Text>

        <DropdownInput
          multiple
          search
          clearable
          placeholder="Digite o nome do estabelecimento"
          options={options}
          value={selectedPlaceIds}
          onChange={onSelectionChange}
        />

        <div className={styles.actions}>
          <Button variant="outline" size="lg" onClick={onClose}>
            cancelar
          </Button>

          <Button
            size="lg"
            onClick={onConfirm}
            disabled={!selectedPlaceIds.length}
          >
            selecionar
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ExportFareModal;
